import web3 from "web3";
import { RUSD_address } from "./constents";
import { rpc } from "./constents";
import RUSD_ABI from "./RUSDabi.json";

export const RUSD_contract_BSC = () => {
  try {
    const web3Instance = new web3(new web3.providers.HttpProvider(rpc.BSC));
    const contract = new web3Instance.eth.Contract(RUSD_ABI, RUSD_address.BSC);
    return contract;
  } catch (error) {
    console.error("Error creating BSC contract instance:", error);
    return null;
  }
};

export const RUSD_contract_ETH = () => {
  try {
    const web3Instance = new web3(new web3.providers.HttpProvider(rpc.ETH));
    const contract = new web3Instance.eth.Contract(RUSD_ABI, RUSD_address.ETH);
    return contract;
  } catch (error) {
    console.error("Error creating ETH contract instance:", error);
    return null;
  }
};

// combine total supply from both chains
export const getTotalSupply = async () => {
  try {
    const contractBSC = RUSD_contract_BSC();
    const contractETH = RUSD_contract_ETH();

    if (!contractBSC || !contractETH) {
      throw new Error("Failed to create contract instances.");
    }

    const supplyBSC = await contractBSC.methods.totalSupply().call();
    const supplyETH = await contractETH.methods.totalSupply().call();

    const totalSupply = web3.utils.fromWei(
      (supplyBSC + supplyETH).toString(),
      "ether",
    );

    return Number(totalSupply).toFixed(2);
  } catch (error) {
    console.error("Error fetching total supply:", error);
    return null;
  }
};
